import React, { useState, useEffect } from 'react';
import { NavLink, useParams } from 'react-router-dom';

import ImageSkeleton from '../../components/Skeleton/ImageSkeleton';
import TextSkeleton from '../../components/Skeleton/TextSkeleton';
import ListSkeleton from '../../components/Skeleton/ListSkeleton';

import IcoCheck from '../../assets/images/check.svg';
import LogoLPG from '../../assets/images/logo-lpg.png';
import LogoWLPGA from '../../assets/images/logo-wlpga.png';

import { getSolucion } from '../../config/services/strapi/strapi';

import { Solucion } from '../../interfaces/types';

function DetalleSolucion() {
  const [cargando, setCargando] = useState(true);
  const [solucion, setSolucion] = useState<Solucion | null>(null);
  const { slug } = useParams();

  useEffect(() => {
    const fetchSolucion = async () => {
      setCargando(true);
      const rawSolucion = await getSolucion(slug as string);
      if (!rawSolucion) {
        console.error('Solución no encontrada');
        return;
      }

      document.title = `${rawSolucion?.nombre} | Gasco Soluciones Energéticas`;

      setSolucion({
        id: rawSolucion.id,
        banner: rawSolucion.banner ? {
          url: rawSolucion.banner.url
        } : undefined,
        beneficios: rawSolucion.beneficios,
        caracteristicas: rawSolucion.caracteristicas,
        descripcion: rawSolucion.descripcion,
        externo: rawSolucion.externo,
        icono: {
          url: rawSolucion.icono.url
        },
        imagenBeneficios: rawSolucion.imagen_beneficios ? {
          url: rawSolucion.imagen_beneficios.url
        } : undefined,
        imagenIndustria: rawSolucion.imagen_industria ? {
          url: rawSolucion.imagen_industria.url
        } : undefined,
        imagenProyectos: rawSolucion.imagen_proyectos ? {
          url: rawSolucion.imagen_proyectos.url
        } : undefined,
        industrias: rawSolucion.industrias,
        nombre: rawSolucion.nombre,
        portada: {
          url: rawSolucion.portada.url
        },
        url: rawSolucion.url
      });

      setCargando(false);
    };

    setSolucion(null);

    fetchSolucion();
  }, [slug]);

  return (
    <main>
      {/* Hero */}
      <section className='w-full relative'>

        {
          cargando ?

            <div className='w-full h-full relative'>
              <ImageSkeleton className="w-full !h-[300px] lg:!h-[424.5px]" />
              <div className='absolute inset-0 left-0 top-0 w-full h-full bg-black opacity-30'></div>
            </div>

            :

            <>
              <div className='absolute left-[15px] md:left-10 lg:left-[102px] xl:left-36 h-full flex flex-col justify-center items-start'>
                <h1 className='!text-white !text-[25.5px] md:!text-[34px] xl:!text-[48px] !font-[600] !leading-[30.6px] md:!leading-[40.8px]'>{solucion?.nombre || 'Cargando...'}</h1>
                <NavLink
                  to="/contacto"
                  className='!w-auto !text-white !text-[11.9px] xl:!text-[16.8px] !font-[400] leading-[17.85px] !bg-[var(--background-color-primary)] flex justify-center items-center !mt-[17px] !px-[18.5px] xl:!px-[22.5px] py-[11.05px] xl:!py-[16.4px] border-[1px] border-[var(--border-color-secondary)] rounded-lg'
                >
                  Contacta a un especialista
                </NavLink>
              </div>
              <figure className='w-full h-auto !m-0 !h-[300px] lg:!h-[424.5px] xl:h-[500px] 2xl:!h-[600px]'>
                <img src={solucion?.banner?.url} className='w-full h-full object-cover' alt="" />
              </figure>
            </>
        }

      </section>
      {/* Descripcion */}
      <section>
        <div className="h-full flex flex-col lg:flex-row lg:items-start lg:gap-10">
          <div className="w-full h-full px-[15px] lg:pl-[102px] lg:pr-0 py-[17px]">
            {
              cargando ?

                <ImageSkeleton className='w-[75px] h-[75px] rounded-full overflow-hidden !mt-8 !mb-[17px]' />

                :

                <figure className='!mx-0 !p-0 !mt-8 !mb-[17px]'>
                  <img className='w-[75px]' src={solucion?.icono?.url} alt={solucion?.nombre} />
                </figure>
            }
            <div>
              {
                cargando ?

                  <TextSkeleton />

                  :

                  solucion?.descripcion.map((item: any, itemindex: number) => {
                    if (item.type === 'paragraph') {
                      return (
                        <p key={`item-${itemindex}`} className='!text-[11.9px] xl:!text-[16.8px] !leading-[19.04px] xl:!leading-[28.8px] !font-[400] lg:px-0 mb-[17px]'>
                          {
                            item.children.map((child: any, childIndex: number) => {
                              if (child.type === 'text') {
                                return (
                                  <span key={`item-${itemindex}-${childIndex}`} className='!text-[var(--text-color-primary)]'>
                                    {child.text}
                                  </span>
                                );
                              }

                              if (child.type === 'link') {
                                return (
                                  <NavLink key={`item-${itemindex}-${childIndex}`}
                                    to={child.url}
                                    className='!text-[var(--text-color-secondary)]'
                                  >
                                    {child.children[0]?.text || ''}
                                  </NavLink>
                                );
                              }
                            })
                          }
                        </p>
                      )
                    }

                    else if (item.type === 'list') {
                      return (
                        <ul key={`item-${itemindex}`} className='list-disc pl-5 mb-4 !list-["_-_"] !apearance-none'>
                          {
                            item.children.map((listItem: any, listIndex: number) => (
                              <li key={`item-${itemindex}-${listIndex}`} className='!text-[var(--text-color-primary)] !text-[11.9px] xl:!text-[16.8px] !leading-[21.42px] xl:!leading-[28.8px] !font-[400]'>
                                <span>{listItem.children[0]?.text || ''}</span>
                              </li>
                            ))
                          }
                        </ul>
                      )
                    }
                  })
              }
            </div>
          </div>
          <div className="w-full h-full pt-[51px] pb-[34px] px-[15px] lg:px-0 bg-[rgb(221,221,221)] lg:!h-[385px]"></div>
        </div>
      </section>
      {/* Características */}
      <section>
        <div className="px-[15px] lg:px-[102px] py-[68px] grid grid-cols-12 gap-4 md:gap-8">
          {
            cargando ?

              Array.from({ length: 4 }).map((_, index) => (
                <div className="col-span-12 md:col-span-3">
                  <ImageSkeleton className='w-[75px] h-[75px] rounded-full overflow-hidden !mt-8 !mb-[17px]' />
                  <TextSkeleton />
                </div>
              ))

              :

            solucion?.caracteristicas?.map((caracteristica: any, index: number) => (
              <div key={`caracteristica-${index}`} className="col-span-12 md:col-span-3">
                <figure className='flex justify-start !p-0 !mx-0 !my-0'>
                  <img className='w-[60px]' src={caracteristica.imagen.url} alt={caracteristica.imagen.alternativeText || 'Imagen'} />
                </figure>
                <div className="text-[var(--text-color-primary)]">
                  {
                    caracteristica.contenido.map((contenido: Record<string, any>, cIndex: number) => {

                      if (contenido.type === 'paragraph') {
                        return (<p className="mb-4 !text-[11.9px] xl:!text-[16.8px] !font-[400] !leading-[19.04px] xl:!leading-[28.8px]" key={`contenido-${cIndex}`}>
                          {
                            contenido.children.map((child: Record<string, any>, childIndex: number) => {
                              if (child.type === 'text' && !child.bold && !child.italic) {
                                return <span key={`child-${cIndex}-${childIndex}`} >{child.text}</span>;
                              }

                              else if (child.type === 'text' && child.bold) {
                                return <span key={`child-${cIndex}-${childIndex}`} className="!font-bold">{child.text}</span>;
                              }

                              else if (child.type === 'text' && child.italic) {
                                return <span key={`child-${cIndex}-${childIndex}`} className="!italic">{child.text}</span>;
                              }

                              else if (child.type === 'text' && child.bold && child.italic) {
                                return <span key={`child-${cIndex}-${childIndex}`} className="!font-bold !italic">{child.text}</span>;
                              }

                              else return null;
                            })
                          }
                        </p>)
                      }

                      else if (contenido.type === 'heading') {
                        if (contenido.level === 2) {
                          return (
                            <h2 className="mb-4 !text-[24px] !font-[700] leading-[32px] text-[var(--text-color-secondary)]" key={`contenido-${cIndex}`}>
                              {
                                contenido.children.map((child: Record<string, any>, childIndex: number) => {
                                  if (child.type === 'text') {
                                    return <span key={`child-${cIndex}-${childIndex}`}>{child.text}</span>;
                                  }
                                  return null;
                                })
                              }
                            </h2>
                          );
                        }

                        else if (contenido.level === 3) {
                          return (
                            <h3 className="mb-4 !text-[20px] !font-[700] leading-[28px] text-[var(--text-color-secondary)]" key={`contenido-${cIndex}`}>
                              {
                                contenido.children.map((child: Record<string, any>, childIndex: number) => {
                                  if (child.type === 'text') {
                                    return <span key={`child-${cIndex}-${childIndex}`}>{child.text}</span>;
                                  }
                                  return null;
                                })
                              }
                            </h3>
                          );
                        }

                        else if (contenido.level === 4) {
                          return (
                            <h4 className="mb-4 !text-[14.45px] xl:!text-[20.4px] !font-[500] leading-[20.23px] text-[var(--text-color-primary)]" key={`contenido-${cIndex}`}>
                              {
                                contenido.children.map((child: Record<string, any>, childIndex: number) => {
                                  if (child.type === 'text') {
                                    return <span key={`child-${cIndex}-${childIndex}`}>{child.text}</span>;
                                  }
                                  return null;
                                })
                              }
                            </h4>
                          );
                        }

                        else if (contenido.level === 5) {
                          return (
                            <h5 className="mb-4 !text-[16px] !font-[700] leading-[24px] text-[var(--text-color-secondary)]" key={`contenido-${cIndex}`}>
                              {
                                contenido.children.map((child: Record<string, any>, childIndex: number) => {
                                  if (child.type === 'text') {
                                    return <span key={`child-${cIndex}-${childIndex}`}>{child.text}</span>;
                                  }
                                  return null;
                                })
                              }
                            </h5>
                          );
                        }

                        else if (contenido.level === 6) {
                          return (
                            <h6 className="mb-4 !text-[14px] !font-[700] leading-[22px] text-[var(--text-color-secondary)]" key={`contenido-${cIndex}`}>
                              {
                                contenido.children.map((child: Record<string, any>, childIndex: number) => {
                                  if (child.type === 'text') {
                                    return <span key={`child-${cIndex}-${childIndex}`}>{child.text}</span>;
                                  }
                                  return null;
                                })
                              }
                            </h6>
                          );
                        }

                      }
                      
                    })
                  }
                </div>
              </div>
            ))
          }
        </div>
      </section>
      {/* Beneficios */}
      <section>
        <div className='mb-[102px] flex flex-col lg:flex-row lg:items-center lg:gap-10'>
          {
            cargando ?

              <ImageSkeleton className='w-full h-[300px] lg:h-[480px] rounded-sm overflow-hidden' />

              :

              <figure className='w-full !p-0 !m-0'>
                {solucion?.imagenBeneficios && <img className='w-full !h-[288.743px] md:!h-[521px] lg:!h-[350px] xl:!h-[480px] object-cover' src={solucion?.imagenBeneficios?.url} alt={`Beneficios de ${solucion?.nombre}`} />}
              </figure>
          }
          <div className='w-full px-[15px] lg:pr-[102px] py-[34px] lg:pt-0'>
            <h4 className='!text-[var(--text-color-primary)] !text-[27.2px] lg:!text-[34px] xl:!text-[48px] !font-[600] !leading-[32.64px] !mt-0 !mb-[34px]'>
              Más beneficios, <br /><br className='hidden lg:block' /> menos emisiones
            </h4>
            <ul>
              {
                cargando ?

                  <ListSkeleton />

                  :

                  solucion?.beneficios[0]?.children?.map((beneficio: any, bIndex: number) => (
                    <li key={`beneficio-${bIndex}`} className='flex justify-start items-start gap-2 !text-[var(--text-color-primary)] !text-[14.5px] xl:!text-[24px] !leading-[21.42px] xl:!leading-[36px] !font-[400] mb-2'>
                      <img src={IcoCheck} alt="Check" className='w-[21.25px] h-auto mt-1' />
                      <span>{beneficio.children[0]?.text || ''}</span>
                    </li>
                  ))
              }
            </ul>
          </div>
        </div>
      </section>
      {/* Proyectos */}
      <section>
        <div className='relative'>
          <div className="absolute w-full top-[59.5px] left-0 flex justify-center items-center flex-col">
            <h4 className='px-[15px] text-center !text-white !text-[25.5px] lg:!text-[34px] !font-[600] !leading-[30.6px] !mt-0'>Proyectos de {solucion?.nombre}</h4>
            <NavLink
              to="/casos-de-exito"
              className='!text-[var(--text-color-secondary)] !text-[11.9px] xl:!text-[16.8px] !font-[400] leading-[17.85px] !bg-white flex justify-center items-center !mt-[17px] px-[18px] py-[11.05px] border-[1px] border-white rounded-lg'
            >
              Conoce los Casos de Éxito
            </NavLink>
          </div>
          {
            cargando ?

              <ImageSkeleton className='w-full !h-[300px] xl:!h-[480px] object-cover' />

              :
              
              <figure className="!p-0 !m-0">
                <img className='w-full !h-[300px] xl:!h-[480px] object-cover' src={solucion?.imagenProyectos?.url} alt={`Proyectos de ${solucion?.nombre}`} />
              </figure>
          }
        </div>
      </section>
      {/* Miembros de WLPGA */}
      <section className='max-w-full overflow-x-hidden py-[68px] px-[15px] lg:px-[102px] lg:pb-4'>
        <div className="lg:flex lg:items-center w-full gap-24 xl:gap-0">
          <div className="mb-10 lg:w-full xl:w-2/3">
            <h3 className='text-[var(--text-color-primary)] text-[34px] xl:text-[48px] leading-10 xl:leading-[57.6px] !mt-0 !mb-[17px]'>Miembros de<br></br> WLPGA</h3>
            <p className='text-sm xl:text-[20.4px] text-[var(--text-color-primary)] mb-10 mt-6 leading-5 xl:leading-[28.56px] lg:text-left !my-0'>
              Gasco es parte de la Asociación Mundial de GL (WLPGA), agrupación mundial de empresas de la industria y organizaciones vinculadas al sector energético, es la voz autorizada de la industria global del GLP que representa toda la cadena de valor del GLP.
            </p>
          </div>
          <div className="flex flex-col md:flex-row justify-center items-center gap-4 lg:gap-6 px-16 md:px-64 lg:px-36 xl:px-56 lg:w-full">
            <img src={LogoLPG} alt="" />
            <img src={LogoWLPGA} alt="" />
          </div>
        </div>
      </section>
    </main>
  )
}

export default DetalleSolucion;